import React, { useEffect, useState } from "react";



import { useAuthState } from "react-firebase-hooks/auth";
import { firebaseAuth } from "../../components/firebase/auth";
import { useNavigate } from "react-router-dom";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Tabs from "@mui/material/Tabs";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import PlantsMain from "./PlantsMain";
import PlantsCustom from "./PlantsCustom";
import PlantsFavourites from "./PlantsFavorites";

import "./Plants.css";

const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#44a99a",
    },
  },
});

function Plants() {
  const [user, loading, error] = useAuthState(firebaseAuth);
  const navigate = useNavigate();

  const [tabValue, setTabValue] = useState("1");
  const [authLoading, setAuthLoading] = useState(true);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (user === null && loading === false) {
      navigate("/login");
    } else if (user !== null && loading === false) {
      setAuthLoading(false);
    }
  }, [loading]);

  return (
    <div className="Plants">
      <TabContext value={tabValue}>
        <ThemeProvider theme={theme}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ maxWidth: "90%" }}
            indicatorColor={"primary"}
          >
            <Tab label="Archive" value="1" />
            <Tab label="Favourites" value="2" />
            <Tab label="Custom" value="3" />
          </Tabs>
        </ThemeProvider>
        <TabPanel
          sx={{
            width: "100%",
            padding: 0,
            maxWidth: "1200px",
          }}
          value="1"
        >
          <PlantsMain />
        </TabPanel>
        <TabPanel
          sx={{
            width: "100%",
            padding: 0,
            maxWidth: "1200px",
          }}
          value="2"
        >
          <PlantsFavourites />
        </TabPanel>
        <TabPanel
          sx={{
            width: "100%",
            padding: 0,
            maxWidth: "1200px",
          }}
          value="3"
        >
          <PlantsCustom />
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default Plants;
